export { default } from './AlertsManagerPage';
